import { useHttp } from '@/api'
import { httpApi } from '@/api/api'

/**
 * 出荷一覧：検索条件リストの初期化(有無状態、請求状態、出荷状態、得意先リスト、ユーザーリスト、仕入先リスト)
 */
export function initSendSearchList(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.InitSendSearchList, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 出荷一覧：検索出荷一覧情報
 */
export function searchSendBasic(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchSendBasic, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 出荷一覧：出荷No.によると、出荷基本情報と明細情報の削除
 */
export function deleteSendBasicByNo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.DeleteSendBasicByNo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 出荷詳細画面：出荷No.によると、出荷基本情報と明細情報の検索
 */
export function searchSendDetailByNo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchSendDetailByNo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 出荷詳細画面: 出荷No.によると、出荷基本情報と明細情報の更新
 */
export function updateSendDetail(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.UpdateSendDetail, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 出荷詳細画面: 出荷基本情報と明細情報の新規追加
 */
export function addSendDetail(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.AddSendDetail, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 出荷製品選択画面：情報の検索
 */
export function searchSendSelectInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchSendSelectInfo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 出荷製品選択画面：情報の検索⇒出荷詳細
 */
export function getSendSelect(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetSendSelect, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 得意先締め日の取得
 */
export function getCusCalculateDate(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetCusCalculateDate, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 納品異常処理画面：注文明細データ、受注明細データの取得
 */
export function getAcceptOrderAndOrderDetail(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetAcceptOrderAndOrderDetail, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 納品異常処理画面：納品異常情報は注文情報、受注情報に保存される
 */
export function saveSendErrorData(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SaveSendErrorData, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// ADD 2025/07/01 Wjx 課題_数量·納期調整機能の追加 start↓

/**
 * 納品異常画面：データ検索
*/
export function searchSendProdInfoByProdNo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchSendProdInfoByProdNo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 納品異常画面：データ更新
*/
export function updateSendNgInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.UpdateSendNgInfo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// ADD 2025/07/01 Wjx 課題_数量·納期調整機能の追加 end↑
